<div class="se-dashboard">
    <header class="se-dashboard__header">
        <h2>Tu Perfil Socioemocional</h2>
        <p>
            Descubre cómo enfrentas situaciones que implican tus
            <strong>emociones, relaciones, decisiones, resiliencia, adaptación y motivación</strong> 🧠 💬 🌱.
        </p>
    </header>

    <div class="se-dashboard__intro">
        <p>Evalúa 7 competencias clave:</p>
        <ul class="se-dashboard__skills-list">
            <li><span>🧠</span> <strong>Autoconocimiento</strong> – Entender lo que piensas, sientes y necesitas.</li>
            <li><span>🎯</span> <strong>Autorregulación</strong> – Manejar tus emociones en momentos difíciles.</li>
            <li><span>👀</span> <strong>Conciencia del Otro</strong> – Comprender y conectar con los demás.</li>
            <li><span>🤝</span> <strong>Habilidades de Relación</strong> – Comunicarte bien y trabajar en equipo.</li>
            <li><span>❄️</span> <strong>Decisiones Responsables</strong> – Elegir lo correcto con conciencia.</li>
            <li><span>🌿</span> <strong>Resiliencia y Adaptación</strong> – Superar cambios y desafíos.</li>
            <li><span>🔥</span> <strong>Propósito y Motivación</strong> – Tener metas claras y energía para lograrlas.
            </li>
        </ul>
    </div>

    <div class="se-dashboard__levels">
        <p>Cada una se clasifica en uno de estos niveles:</p>
        <div class="se-dashboard__badges">
            <span class="se-dashboard__badge se-dashboard__badge--orange">🟠 Estoy empezando</span> |
            <span class="se-dashboard__badge se-dashboard__badge--yellow">🟡 En desarrollo</span> |
            <span class="se-dashboard__badge se-dashboard__badge--blue">🔵 Competente</span> |
            <span class="se-dashboard__badge se-dashboard__badge--green">🟢 Consolidado</span>
        </div>
    </div>

    <p class="se-dashboard__note">
        Esta seccion es una guía para conocerte mejor y seguir creciendo 🙌📈.
    </p>

</div>